import lodash from 'lodash'
import moment from 'moment'
import { filter } from '../../../../utils/search'
import Base from '../base.store'
import request from "../../../../utils/request";

const baseUrl = '/api/v1/security/users'
const base = new Base(baseUrl)

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {}),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        changePassword(context, { data, config }) {
            return base.request.put(`${baseUrl}/change-password`, data, { ...config })
        },
        meProfile(context, { config }) {
            return base.request.get(`${baseUrl}/me/profile`, { ...config })
        },
        meProfileUpdate(context, { data, config }) {
            return base.request.put(`${baseUrl}/me/profile`, data, { ...config })
        },
        meChangePassword(context, { data, config }) {
            return base.request.put(`${baseUrl}/me/change-password`, data, { ...config })
        },
        changePasswordChildren(context, { data, config }) {
            return base.request.put(`${baseUrl}/change-password-children`, data, { ...config })
        },
        cacheFindAll(context, { searchQuery }) {
            let force = false;
            const cacheDateResult = context.state.cacheDate.list;
            if (cacheDateResult && cacheDateResult.isBefore(moment())) {
                force = true
            }
            const where = [
                { name: 'fullName', operator: 'like', value: searchQuery },
            ]
            const sort = [{ name: 'fullName', type: 'asc' }]
            const list = context.state.list || []
            if (list.length > 0 && !force) {
                return filter({ list, where, sort })
            }
            return context.dispatch('findAll', { criteria: { select: ['id', 'fullName', 'refTitle.value', 'refImage.url'] } })
                .then(list => filter({ list, where, sort }))
        },
        saveChildrenCompany(context, { data, config }) {
            return  base.request.put(`${baseUrl}/children`, data, { ...config })
        },
        activeChildrenCompany(context, { id, config }) {
            return request.post(`${baseUrl}/_active_children`, JSON.stringify(id), { ...config })
        },
        activeAllChildrenCompany(context, { ids, config }) {
            return request.post(`${baseUrl}/_active_all_children`, ids, { ...config })
        },
        deleteChildrenCompany(context, { id, config }) {
            return request.post(`${baseUrl}/_delete_children`, JSON.stringify(id), { ...config })
        },
        deleteAllChildrenCompany(context, { ids, config }) {
            return request.post(`${baseUrl}/_delete_all_children`, ids, { ...config })
        },
    },
    mutations: {
        ...base.mutations
    },
}
